import { createAction } from 'typesafe-actions'

import { Id } from 'src/types'

import { AgreementActionTypes, ResponseDataRequests } from './types'

type Options = {
  page?: number
  agency_partner_id: Id
  partner_hotel_room_id?: Id
  request_agency_ids?: string[]
}

export const getAgreement = createAction(
  AgreementActionTypes.GET_AGREEMENT,
  action =>
    (
      options = {
        page: 1,
        agency_partner_id: ''
      } as Options
    ) =>
      action({ options })
)

export const getAgreementFailure = createAction(
  AgreementActionTypes.GET_AGREEMENT_FAILURE,
  action => (message: string) => action({ message })
)

export const getAgreementSuccess = createAction(
  AgreementActionTypes.GET_AGREEMENT_SUCCESS,
  action =>
    ({ agreements }: ResponseDataRequests) =>
      action({ agreements })
)

export const sendAgreement = createAction(
  AgreementActionTypes.SEND_AGREEMENT,
  action =>
    (
      agreements: [
        {
          organization_id: Id
          agency_partner_id: Id
        }
      ]
    ) =>
      action({ agreements })
)

export const sendAgreementFailure = createAction(
  AgreementActionTypes.SEND_AGREEMENT_FAILURE,
  action => (message: string) => action({ message })
)

export const sendAgreementSuccess = createAction(
  AgreementActionTypes.SEND_AGREEMENT_SUCCESS,
  action => () => action()
)
